<template>
    <div class="ctaArea secPdng  animated">
        <div class="container">
            <div class="row ctaRow">
                <div class="col-md-6">
                    <div class="ctaImgOne">
                        <img src="../../assets/images/new_logos/answerdash_outcome.gif" alt="">
                    </div>
                </div>
                <div class="col-md-6 ctaCol">
                    <div class="ctaRight ctaTxt">
                        <div class="ctaCell">
                            <div class="h2">Faça pagamentos de forma confortável</div>
                            <p>Use a sua conta <span>Quick-e-Pay</span> para fazer pagamentos de compras, propinas e
                                outros serviços sem sair de casa e com segurança.</p>
                            <p>Livre-se de processos complicados de envio de talões de depósito ou memorização de
                                códigos complicados para pagamento com tempos longos de espera e veja o seu pagamento a
                                reflectir de forma
                                instantânea.</p>

                            <router-link :to="{name: 'per-how-to'}" :class="'ctaBtn Btn'">Saiba mais</router-link>
                            <!--<a href="#" class="ctaBtn Btn">Saiba mais!</a>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="row ctaRow  ">
                <div class="col-md-6 ctaCol">
                    <div class="ctaLeft ctaTxt">
                        <div class="ctaCell">
                            <div class="h2">Ganhe tempo para investir no seu negócio</div>
                            <p>Use as ferramentas para retalho, ecommerce, facturamento e doação do
                                <span>Quick-e-Pay</span> para aceitar pagamentos
                                a partir de qualquer conta (carteira móvel, conta bancária ou cartão de débito/crédito).
                            </p>
                            <p>
                                Receba a liquidação directamente na sua conta bancária sempre que solicitar ou de forma
                                programada.
                            </p>
                            <div class="ctaBtn">
                                <router-link :class="'btnOne Btn'" :to="{name: 'bus-solutions'}">Saiba mais
                                </router-link>
                                <a :href="settings.app_url+'/register'" class="btnTwo Btn">Regista-te já!</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 col-md-offset-1 ctaColBtm">
                    <div class="ctaImgTwo">
                        <img src="../../assets/images/new_logos/answerdash_steps_2.gif" alt="">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div>
                        <img src="../../assets/images/new_logos/app-business.svg" width="70%" alt="">
                    </div>
                </div>
                <div class="col-md-6 ctaCol">
                    <div class="ctaRight ctaTxt">
                        <div class="ctaCell">
                            <div class="h2">Torne o seu negócio mais atraente</div>
                            <p>Dê uma nova dinâmica e visibilidade ao seu negócio fornecendo aos seus clientes uma forma
                                inteligente de interacção com pagamentos e usufrua, ao mesmo tempo, do controlo total da
                                gestão das suas finanças.</p>
                            <a :href="settings.app_url+'/register'"class="ctaBtn Btn"><i class="icofont icofont-rocket-alt-2"></i>Comece já!</a>
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="row">-->
            <!--<div class="col-md-6 ctaCol">-->
            <!--<div class="ctaLeft ctaTxt">-->
            <!--<div class="ctaCell">-->
            <!--<div class="h2">sd</div>-->
            <!--<p>Livra-te das complicações de integração de pagamentos ou serviços e <br>permita que os-->
            <!--seus clientes façam-->
            <!--pagamentos de qualquer conta (carteira móvel, conta bancária ou mesmo associar cartões).-->
            <!--</p>-->
            <!--<div class="ctaBtn">-->
            <!--<a href="#" class="btnOne Btn">Saiba mais</a>-->
            <!--<a :href="settings.app_url+'/register'" class="btnTwo Btn">Regista-te já!</a>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--<div class="col-md-5 col-md-offset-1 ctaColBtm">-->
            <!--<div class="ctaImgTwo">-->
            <!--<img src="../../assets/images/new_logos/deflection-search.png" alt="">-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>
  import Settings from '@/database/settings.json'

  export default {
    name: 'site-why-us',
    data() {
      return {
        settings: Settings
      }
    },
  }
</script>

<style scoped>
    span {
        color: #288feb;
        font-weight: bold;
    }

</style>



// WEBPACK FOOTER //
// src/components/site/SiteWhyUs.vue